import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "service/ApiService";
import { notify } from "service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";

export default function CreateProductPage() {
  const backRoute = "/admin/products";
  const history = useHistory();
  const { id } = useParams();
  const [productId, setProductId] = useState(null);
  const [productName, setProductName] = useState("");
  const [productVatNumber, setProductVatNumber] = useState(0);
  const [productPrice, setProductPrice] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);

  const handleError = (error) => notify("error", error);
  const handleCreate = (create) => notify("create", create);
  const handleUpdate = (update) => notify("update", update);

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/products/${id}`)
      .then((product) => {
        console.log(product);
        fillFields(product);
      })
      .catch((error) => {
        handleError(error.message);
        history.push(backRoute);
      });
  }, []);

  const handlePriceChange = (event) => {
    const input = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(input)) setProductPrice(input);
  };

  const save = () => {
    setIsDisabled(true);
    const product = {
      name: productName,
      vat: productVatNumber ? productVatNumber : 0,
      price: productPrice ? productPrice : 0,
    };

    if (id) {
      apiService
        .putJson(`api/products/${id}`, product)
        .then((resp) => {
          handleUpdate("The product saved successfully");
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          handleError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/products", product)
        .then((resp) => {
          handleCreate("The product created successfully");
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          handleError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (product) => {
    setProductId(product._id);
    setProductName(product.name);
    setProductVatNumber(product.vat);
    setProductPrice(product.price.toFixed(2));
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">{id ? "Edit Product" : "Create Product"}</h6>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">Product Details</h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                    product Name
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Product Name"
                    required={true}
                    value={productName}
                    onChange={(e) => {
                      setProductName(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                    Price
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Price"
                    required={true}
                    value={productPrice}
                    onChange={handlePriceChange}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                    VAT
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="VAT"
                    required={true}
                    value={productVatNumber}
                    onChange={(e) => {
                      setProductVatNumber(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <hr className="mt-6 border-b-1 border-blueGray-300" />
            <div className="pt-4">
              {id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}
            </div>
            {errorMessage ? (
              <>
                <p style={{ color: "crimson" }}>
                  <i className="fa fa-exclamation-circle"></i> {errorMessage}
                </p>
              </>
            ) : null}
          </form>
        </div>
      </div>
    </>
  );
}
